import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { AdminResourcesRoutes } from '@repo/shared/api-routes/admin/resources'
import { AxiosInstance } from 'axios'

import { buildResourceFromDto } from '@/external/api/helpers'
import { IResourcesApi } from '@/spi/api/resources'

export const buildResourcesApi = (axios: AxiosInstance): IResourcesApi => ({
  getAll: async ({ organizationId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof AdminResourcesRoutes.getAll.response>(
        AdminResourcesRoutes.getAll.getPath({ organizationId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data.map(buildResourceFromDto)
  },

  createOne: async ({ organizationId, fields }) => {
    const response = await tryCatch(async () =>
      axios.post<typeof AdminResourcesRoutes.createOne.response>(
        AdminResourcesRoutes.createOne.getPath({ organizationId }),
        { payload: fields } satisfies typeof AdminResourcesRoutes.createOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildResourceFromDto(response.data)
  },

  deleteOne: async ({ organizationId, resourceId }) => {
    const response = await tryCatch(async () =>
      axios.delete<typeof AdminResourcesRoutes.deleteOne.response>(
        AdminResourcesRoutes.deleteOne.getPath({
          organizationId,
          resourceId,
        }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  updateOne: async ({ organizationId, resourceId, fields }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof AdminResourcesRoutes.updateOne.response>(
        AdminResourcesRoutes.updateOne.getPath({
          organizationId,
          resourceId,
        }),
        { payload: fields } satisfies typeof AdminResourcesRoutes.updateOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildResourceFromDto(response.data)
  },

  restoreOne: async ({ organizationId, resourceId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof AdminResourcesRoutes.restoreOne.response>(
        AdminResourcesRoutes.restoreOne.getPath({
          organizationId,
          resourceId,
        }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildResourceFromDto(response.data)
  },
})
